import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useRouteMatch } from 'react-router-dom';
import { SideMenu, SideMenuItem, LogoHp } from '@veneer/core';
import SubscriptionContext from 'src/context/subscription';
import { useParamsQuery, deleteQuery } from 'src/hooks/useQuery';
import { storeSubscription } from 'src/storage/subscription';
import FlipperCheck from 'src/hooks/flipperCheck';
import { ContentWrapper, ContainerLayout, SideMenuContainer } from './styles';

const Layout = ({ children }) => {
  const query = useParamsQuery();
  const subscriptionId = query.get('subscriptionId');
  const token = query.get('token');

  const { subscriptionContext, setSubscriptionContext } =
    useContext(SubscriptionContext);

  if (subscriptionId || token) {
    const newSubscriptionContext = {
      ...subscriptionContext,
      subId: subscriptionId,
      token,
    };

    storeSubscription({
      subId: subscriptionId,
      token,
    });

    FlipperCheck(subscriptionId);
    setSubscriptionContext(newSubscriptionContext);
    deleteQuery({ subscriptionId, token });
  }

  const childrenMenuItems = [
    { label: 'Ordered', url: '/supplies/ordered' },
    { label: 'Available', url: '/supplies/available' },
  ];

  if (
    subscriptionContext.flipperContext.flipper !== undefined &&
    !subscriptionContext.flipperContext.flipper
  ) {
    childrenMenuItems.push({
      label: 'Stock Alignment',
      url: '/supplies/stock-alignment',
    });
  }

  const menu = [
    { label: 'Billing', url: '/billing' },
    subscriptionContext.flipperContext.flipper !== undefined &&
      !subscriptionContext.flipperContext.flipper && {
        label: 'Supplies',
        url: null,
        children: childrenMenuItems,
      },
    /* : { label: 'Supplies', url: '/supplies' }, */
  ];

  const renderMenu = (item) =>
    item.map((m) => {
      const match = useRouteMatch(m.url);
      let selected = false;

      if (match && match.isExact && m.url) {
        selected = true;
      }
      return (
        <SideMenuItem
          label={m.label}
          url={m.url}
          key={`${m.label}-${m.url}`}
          selected={selected}
          expanded
        >
          {m.children && renderMenu(m.children)}
        </SideMenuItem>
      );
    });

  const openTicket = (
    <SideMenuItem
      expandable={false}
      icon={<LogoHp appearance="multicolor" />}
      key="open-ticket"
      label="Open Ticket"
      url="https://app.smartsheet.com/b/form/46934721a4c44bc8a31cf5070c354e2a"
      urlTarget="_blank"
      style={{ marginTop: 'auto' }}
    />
  );

  return (
    <ContainerLayout>
      <SideMenuContainer>
        <SideMenu
          appName="3D Subscription"
          logo={<LogoHp appearance="multicolor" />}
          className="veneerMenu"
          showIcons
        >
          {subscriptionContext.flipperContext.flipper !== undefined &&
            renderMenu(menu)}
          {openTicket}
        </SideMenu>
      </SideMenuContainer>
      <ContentWrapper>{children}</ContentWrapper>
    </ContainerLayout>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
